import apiClient from './apiClient';

// One catalog request is shared by every selector on the page; callers keep their own aborted-guards, so the shared request carries no signal.
let catalogPromise = null;
export const creatorIntelligenceService = {
  catalog: () => catalogPromise || (catalogPromise = apiClient.get('/creator-intelligence/catalog').then(response => response.data).catch(error => { catalogPromise = null; throw error; })),
  tags: (id, signal) => apiClient.get(`/creator-intelligence/creators/${id}/tags`, { signal }).then(response => response.data),
  decideTag: (id, decision) => apiClient.put(`/creator-intelligence/creators/${id}/tags`, decision).then(response => response.data),
  search: (params, signal) => apiClient.get('/creator-intelligence/creators', { params, signal }).then(response => response.data),
  report: (id, snapshotId, signal) => apiClient.get(`/creator-intelligence/creators/${id}/report`, { params: snapshotId ? { snapshotId } : {}, signal }).then(response => response.data),
};
